import React, { useEffect } from 'react';

import ForwardArrow from '../partials/ForwardArrow'
import BackArrow from '../partials/BackArrow'
import Header from '../partials/Header'
import Questions from './Questions'
import QuestionsHorizontal from './QuestionsHorizontal'
import SliderLanguage from '../partials/SliderLanguage.js'

import pF from "./images/PFpink.jpeg"
import readingBook from './images/readingBookNarrow.jpeg'
import stairs from './images/stairs.jpeg'
import streetSign from './images/streetSign.jpeg'
import sewing from './images/crossStitchWoodCarving.jpeg'
import taxForm from './images/taxForm.jpeg'
import cardGame from './images/cards.jpeg'
import tv from './images/tv.jpeg'


export default function Questionnaire (props) {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])


  let sideLanguage = 
      props.spanish && props.spanish === true
      ? props.side && props.side === 'LEFT'
        ? 'izquierdo' 
        : 'derecho'
      : props.side
      
  
  return(
    <div>
      <BackArrow
        linkTo='/patientinfo'
        />

      <ForwardArrow
        linkTo='/visionsimulator'
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            margin: '10px 0 0 0',
          }}
        >
          <SliderLanguage
            hook={props.spanish}
            setHook={props.setSpanish}
          />
        </div>

        <Header
          title={props.spanish ? 'Califique su visión' : "Rate your vision"}
          subtitle={props.spanish ? `¿Tiene dificultad con su ojo ${sideLanguage}, incluso con gafas, al realizar las siguientes actividades?` : `Do you have difficulty with your ${sideLanguage} eye, even with glasses, while doing the following activities?`}
          />

        <Questions
          title={props.spanish ? '¿Leer letra pequeña como las etiquetas de frascos de medicamentos, una guía telefónica o etiquetas de alimentos?' : "Reading small print such as labels on medicine bottles, a telephone book or food labels?"}
          hook={props.q1}
          setHook={props.setQ1}
          step='2'
          image={pF}
          spanish={props.spanish}
          />
        <Questions
          title={props.spanish ? '¿Leer un periódico o un libro?' : "Reading a newspaper or book?"}
          hook={props.q2}
          setHook={props.setQ2}
          step='1.5'
          image={readingBook}
          spanish={props.spanish}
          />
        <Questions
          title={props.spanish ? '¿Ver escalones, escaleras o bordillos?' : "Seeing steps, stairs or curbs?"}
          hook={props.q3}
          setHook={props.setQ3}
          step='3'
          image={stairs}
          spanish={props.spanish}
          />
        <Questions
          title={props.spanish ? '¿Leer señales de tráfico, señales de calles o letreros de tiendas?' : "Reading traffic signs, street signs or store signs?"}
          hook={props.q4}
          setHook={props.setQ4}
          step='3'
          image={streetSign}
          spanish={props.spanish}
          />
        <Questions
          title={props.spanish ? '¿Realizar trabajos manuales delicados como coser, tejer, hacer crochet o carpintería?' : "Doing fine handwork like sewing, knitting, crocheting or carpentry?"}
          hook={props.q5}
          setHook={props.setQ5}
          step='2'
          image={sewing}
          spanish={props.spanish}
          />
        <Questions
          title={props.spanish ? '¿Escribir cheques o llenar formularios?' : "Writing checks or filling out forms?"}
          hook={props.q6}
          setHook={props.setQ6}
          step='1'
          image={taxForm}
          spanish={props.spanish}
          />
        <Questions
          title={props.spanish ? '¿Jugar juegos como bingo, dominó o cartas?' : "Playing games such as bingo, dominos, or cards?"}
          hook={props.q7}
          setHook={props.setQ7}
          step='2'
          image={cardGame}
          spanish={props.spanish}
          />
        <Questions
          title={props.spanish ? '¿Ver televisión?' : "Watching television?"}
          hook={props.q8}
          setHook={props.setQ8}
          step='2'
          image={tv}
          spanish={props.spanish}
          />
        <div
          style={{height: '50px'}}
        >
        </div>
        <Header
          title={props.spanish ? 'Califique sus síntomas' : "Rate Your Symptoms"}
          subtitle={props.spanish ? `¿Ha tenido molestias en el ojo ${sideLanguage} por alguno de los siguientes motivos?` : `Have you been bothered in the ${sideLanguage} eye by any of the following:`}
          />
        <QuestionsHorizontal
          title={props.spanish ? '¿Mala visión nocturna?' : "Poor night vision?"}
          hook={props.q9}
          setHook={props.setQ9}
          step='0.75'
          spanish={props.spanish}
          />
        <QuestionsHorizontal
          title={props.spanish ? '¿Deslumbramiento causado por luces de autos, farolas o luz solar intensa?' : "Glare caused by headlights, streetlights, or bright sunlight?"}
          hook={props.q10}
          setHook={props.setQ10}
          step='0.75'
          spanish={props.spanish}
          />
        <QuestionsHorizontal
          title={props.spanish ? '¿Visión borrosa y/o nublada?' : "Hazy and/or blurry vision?"}
          hook={props.q11}
          setHook={props.setQ11}
          step='0.75'
          spanish={props.spanish}
          />
        <QuestionsHorizontal
          title={props.spanish ? '¿Ver mal con poca luz?' : "Seeing poorly in dim light?"}
          hook={props.q12}
          setHook={props.setQ12}
          step='0.75'
          spanish={props.spanish}
          />
        <QuestionsHorizontal
          title={props.spanish ? '¿Mala percepción de los colores?' : "Poor color vision?"}
          hook={props.q13}
          setHook={props.setQ13}
          step='0.75'
          spanish={props.spanish}
          />
        <QuestionsHorizontal
          title={props.spanish ? 'La cirugía de cataratas casi siempre se puede posponer de forma segura hasta que usted sienta que necesita una mejor visión. Si un cambio en sus gafas ya no mejora su visión y la única forma de ver mejor es mediante la cirugía de cataratas, ¿siente que sus problemas de visión son lo suficientemente graves como para considerar la cirugía de cataratas ahora?' : "Cataract surgery can almost always be safely postponed until you feel you need better vision.  If a change in glasses won't improve your vision anymore and if the only way to help you see better is cataract surgery, do you feel your vision problems are bad enough to consider cataract surgery now?"}
          hook={props.q14}
          setHook={props.setQ14}
          step='0.75'
          spanish={props.spanish}
          />
        <div
          style={{height: '300px'}}
        >
        </div>
    </div>

  )
}


//credit photographer for

//stairs: By Axcordion at English Wikipedia, CC BY-SA 3.0, https://commons.wikimedia.org/w/index.php?curid=31854843

// cross-stitch: By Sally Wilson 19 - Own work, CC BY-SA 4.0, https://commons.wikimedia.org/w/index.php?curid=75532581

//Woodcarving: The original uploader was Kaiserb at English Wikipedia., CC BY-SA 2.5 <https://creativecommons.org/licenses/by-sa/2.5>, via Wikimedia Commons

//Cards: Photo: Graeme Main/MOD, OGL v1.0OGL v1.0, via Wikimedia Commons

//TV: Julian Tysoe, CC BY 2.0 <https://creativecommons.org/licenses/by/2.0>, via Wikimedia Commons.  https://www.pbs.org/newshour/show/american-mikaela-shiffrin-makes-history-as-most-successful-female-world-cup-skier
